export default {
  // 军训服尺码
  _SIZES: [{
    label: "S",
    value: 'S'
  }, {
    label: "M",
    value: 'M'
  }, {
    label: "L",
    value: 'L'
  }, {
    label: "XL",
    value: 'XL'
  }, {
    label: "2XL",
    value: '2XL'
  }, {
    label: "3XL",
    value: '3XL'
  }, {
    label: "4XL",
    value: '4XL'
  }],
  // 用户分类
  _USER_CATEGORY: [
    {
      label: "教师",
      value: 'teacher'
    },
    {
      label: "学生",
      value: 'student'
    },
    {
      label: "其他",
      value: 'other'
    },
  ],
  // 性别
  _SEXS: [{
    label: "男",
    value: 'male'
  }, {
    label: "女",
    value: 'female'
  }],
  // 是 / 否
  _IS: [{
    label: "是",
    value: 1
  }, {
    label: "否",
    value: 0
  }],
  // 学生状态
  _STUDENT_STATUS: [
    {
      label: "在籍",
      value: '在籍'
    }, {
      label: "不在籍",
      value: '不在籍'
    }
  ],
  _STATUS: [
    {
      label: "已办理",
      value: '1'
    }, {
      label: "未办理",
      value: '0'
    }
  ],
  _CARDTYPE: [
    {
      label: "身份证件",
      value: '0'
    }, {
      label: "港澳台证件",
      value: '1'
    }, {
      label: "护照",
      value: '2'
    }
  ],
  // 组织机构分类
  _ORGAN_TYPE: [
    {
      label: "学院",
      value: 'college'
    },
    {
      label: "系别",
      value: 'department'
    },
    {
      label: "专业",
      value: 'major'
    },
    {
      label: "班级",
      value: 'class'
    },
    {
      label: "其他",
      value: 'other'
    },
  ],
  _HYZK: [{
    label: "未婚",
    value: 0
  }, {
    label: "已婚",
    value: 1
  }, {
    label: "未知",
    value: 2
  }],
  // 培养层次
  // _DEGREE: [
  //   {
  //     label: "专科",
  //     value: '专科'
  //   }, {
  //     label: "本科",
  //     value: '本科'
  //   },
  // ],
  // 学生类型
  _STUDENT_TYPE: [
    { label: '普通学生', value: "0" },
    { label: '体育生', value: "1" },
    { label: '单招', value: "2" },
    { label: '艺术生', value: "3" },
  ],

  // 到校交通方式
  _TRANSPORT_OPTIONS: [
    { label: '火车', value: '火车' },
    { label: '飞机', value: '飞机' },
    { label: '汽车', value: '汽车' },
    { label: '自驾', value: '自驾' },
    { label: '其他', value: '其他' },
  ],

  // 一般接口返回成功状态码
  SUCCESS_CODE: 0,
  // 控制新生入学年份，防止非新生进入
  _CURRENT_YEAR2: 2023,//已废弃，通过接口动态获取
  // 流程相关业务接口返回成功状态码
  SUCCESS_CODE_MODEL: 200,

  // 学生信息导入模板下载地址
  STUDENT_BASE_TEMPLATE: 'http://yx.ezu.cn/static/template/excel/base-student-template.xlsx',

  //入学年份
  ENROLLMENT_YEAR: 2023,

  //配置企业微信基础信息  测试
  /*corpId : "ww71fe8bf4b38df6c1",
  agentId : "1000002",*/

  //配置企业微信基础信息  测试
  corpId : "wxc8e5154001b3437d",
  agentId : "1000055",

  _APP_KEY:'welcome',


}
